import { createStore, applyMiddleware } from "redux";
import { composeWithDevtools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import rootReducer from "../reducers/combineReducers";

const initialState = {};
const middleWare = [thunk];
const store = createStore(
    rootReducer,
    initialState,
    applyMiddleware(...middleWare)
);

export default store;